import { OnInit, OnDestroy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { timer, finalize, takeWhile, takeUntil, tap, Subject } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent implements OnInit, OnDestroy {
  countdown: number = 2;
  countdownMapping: any = {
    '=1': '# second',
    other: '# seconds',
  };
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private _authService: AuthService, private _router: Router) {}

  ngOnInit(): void {
    // Sign out
    this._authService.logout();

    // Redirect after the countdown
    timer(1000, 1000)
      .pipe(
        finalize(() => {
          void this._router.navigate(['/connexion']);
        }),
        takeWhile(() => this.countdown > 0),
        takeUntil(this._unsubscribeAll),
        tap(() => this.countdown--)
      )
      .subscribe();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
